<template>
  <div id="app">
      <p class="news-title">{{info.title}}</p>
      <div class="cont">
        <div v-html="info.content"></div>
      </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      info:[],
      id:'',
    }
  },
  components: {
  },
  created:function () {
      this.$emit('footer', false);
  },

  mounted () {
    this.id = this.$route.query.id;
    this.recordapi();
  },
  	methods: {

      recordapi(){
          var that = this;
          that.$api.post("/Index/about",{'id':that.id}).then(res => {
            console.log(res);
            that.info = res.info;

          });
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue